type GroupingOptions = {
  pinNonParentToTop?: boolean;
};

const getParentGroupKey = (parentField: any): string | null => {
  if (!parentField) {
    return null;
  }
  const parentId =
    parentField.id ?? parentField.fieldid ?? parentField.fieldId ?? null;
  if (parentId !== null && parentId !== undefined) {
    return `id:${parentId}`;
  }
  const parentName =
    parentField.name ?? parentField.fieldname ?? parentField.fieldName ?? null;
  if (parentName) {
    return `name:${parentName}`;
  }
  return "parent";
};

export const groupTableFieldsByParent = <T extends { parentField?: any | null }>(
  fields: T[],
  options: GroupingOptions = {}
): T[] => {
  if (!fields.length) {
    return fields;
  }

  const { pinNonParentToTop = false } = options;
  const groupedByParent = new Map<string, T[]>();
  const parentOrder: string[] = [];

  fields.forEach((field) => {
    const parentKey = getParentGroupKey(field.parentField);
    if (!parentKey) {
      return;
    }
    if (!groupedByParent.has(parentKey)) {
      groupedByParent.set(parentKey, []);
      parentOrder.push(parentKey);
    }
    groupedByParent.get(parentKey)!.push(field);
  });

  const result: T[] = [];
  const appendedParents = new Set<string>();

  fields.forEach((field) => {
    const parentKey = getParentGroupKey(field.parentField);
    if (!parentKey) {
      result.push(field);
      return;
    }
    if (appendedParents.has(parentKey)) {
      return;
    }
    const groupedFields = groupedByParent.get(parentKey);
    if (groupedFields) {
      result.push(...groupedFields);
    } else {
      result.push(field);
    }
    appendedParents.add(parentKey);
  });

  if (!pinNonParentToTop) {
    return result;
  }

  const nonParentFields = result.filter((field) => !getParentGroupKey(field.parentField));
  const parentFields = result.filter((field) => getParentGroupKey(field.parentField));
  return [...nonParentFields, ...parentFields];
};
